import { axiosInstance } from "../../../axios/axiosInstance";

const API_SYSTEM_SETTINGS_URL = "system-settings";
const API_SYSTEM_SETTINGS_VIEW_URL = API_SYSTEM_SETTINGS_URL + "/view";
const API_GET_ORGANIZATION_TOP_LISTING_SUBSCRIPTION_PLAN_URL = "organization/organization-top-listing-subscription-plans/list";

export const getSystemSettings = () => {
  return axiosInstance.get(API_SYSTEM_SETTINGS_VIEW_URL);
};

export const getOrganizationTopListingSubscriptionPlan = (dataToBeSent) => {
  return axiosInstance.get(API_GET_ORGANIZATION_TOP_LISTING_SUBSCRIPTION_PLAN_URL);
};